<template>
    <div class="adj-container">
        <b-modal
            ref="modal"
            size="lg"
            id="modal-adj"
            title="Kerusakan"
            @hidden="onHidden"
            hide-header
            hide-footer
        >
            <b-container class="text-center">
                <h3 class="text-left mb-5 ml-n3">Kerusakan</h3>
                <b-row
                    class="item-container mb-4"
                    v-for="(item, index) in adjustments"
                    :key="index"
                >
                    <b-col cols="3" class="d-flex align-items-center">
                        <h5>{{ item.name }}</h5>
                    </b-col>
                    <b-col cols="9">
                        <div class="img-container">
                            <div
                                class="img-item"
                                v-for="(src, indexImg) in item.image"
                                :key="indexImg"
                                @click="showImage(src)"
                            >
                                <img :src="src" alt="" />
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-button
                    class="mt-3 w-25 button-close btn-outline-dark"
                    @click="$bvModal.hide('modal-adj')"
                    >Tutup</b-button
                >
            </b-container>
        </b-modal>
        <b-modal v-model="showImg" hide-footer centered>
            <div
                style="
                    background-color: rgba(0, 0, 0, 0.5);
                    max-width: 700px;
                    max-height: 80vh;
                "
                class="d-flex align-items-center"
            >
                <img
                    :src="image"
                    style="
                        margin: auto;
                        object-fit: cover;
                        object-position: center;
                        width: 100%;
                        max-height: 70vh;
                    "
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ["isLoading"],
    data() {
        return {
            showImg: false,
            image: "",
            adjustments: [
                {
                    image: [
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-0-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-1-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-2-1678859162.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-3-1678859163.jpg",
                    ],
                    name: "Lcd vignet",
                },
                {
                    image: [
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-0-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-1-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-2-1678859162.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-3-1678859163.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-4-1678859163.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-4-1678859163.jpg",
                    ],
                    name: "Lensa jamur",
                },
                {
                    image: [
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-0-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-1-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-2-1678859162.jpg",
                    ],
                    name: "Prisma jamur",
                },
                {
                    image: [
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-0-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-1-1678859161.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-2-1678859162.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-3-1678859163.jpg",
                        "https://sinarmutiaracell.sgp1.digitaloceanspaces.com/storage/invtrypht/10530220914005-4-1678859163.jpg",
                    ],
                    name: "Conector charger",
                },
            ],
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        onHidden() {
            this.$emit("hidden");
        },
        showImage(img) {
            this.image = img;
            this.showImg = true;
        },
    },
};
</script>

<style scoped>
.adj-container {
    position: relative;
}

.item-container {
    display: flex;
    flex-direction: row;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
}
.img-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    margin: 10px auto;
}

.img-item {
    background: #eee;
}

.img-item img {
    object-fit: cover;
    object-position: center;
    width: 116px;
    height: 116px;

    border-radius: 5px;
}

.button-close {
    background: #fff;
    color: black;
}

.button-close:hover {
    color: black;
}

.b-modal-backdrop {
    display: none;
}
.b-modal {
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    border: none;
    max-width: none;
    width: auto;
    height: auto;
    overflow: visible;
}

.modal-header {
    position: sticky;
    top: 0;
    z-index: 1020;
}

.modal-footer {
    position: sticky;
    bottom: 0;
    z-index: 1020;
}
</style>
